<div class="position-relative">
  <button aria-label="Close" rlstTooltip="Close Modal" tooltipPosition="left" class="close" type="button"
    (click)="close()">
    <span class="sr-only">Close modal</span>
  </button>
  <rlst-add-to-cart *ngIf="documentImageOffer$ | async" [cartItem]="cartItem" [reportIncludes]="reportIncludes"
    (addToCartClicked)="addToCart()" (viewReportClicked)="viewReport()" [noReportExists]="!data?.reportExists"
    [sampleReportTitle]="'Document Image'">
    <p>{{ descriptions[0] }}</p>
    <p>{{ descriptions[1] }} </p>
  </rlst-add-to-cart>
</div>